<template>
    <FooterAuth
        v-if="isLoggedIn && screen.minMD"
        class="items-start"
        :arrangement="FooterAuthArrangement.HORIZONTAL"
        links-centered
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { FooterAuthArrangement } from '@components/TheFooter/FooterAuth';
import { FooterAuth } from '@components/TheFooter';

/**
 * @deprecated Use TheFooter or FooterAuth instead. This component only exist for backwards compatibility.
 *   Ideally, we remove the usage of this component.
 */
export default defineComponent({
    name: 'TheFooterStatic',
    components: {
        FooterAuth,
    },
    data() {
        return {
            FooterAuthArrangement,
        };
    },
    computed: {
        ...mapGetters({
            isLoggedIn: 'auth/isLoggedIn',
            screen: 'ui/screen',
        }),
    },
});
</script>
